// extracted by mini-css-extract-plugin
export default {"textarea":"MyTextarea_textarea__gRNpk","error":"MyTextarea_error__2UNT6"};